import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const APPLICATION_BY_UUID_RESOURCE = "application" as const;
export const APPLICATION_BY_UUID_API_PATH = `/v1/${APPLICATION_BY_UUID_RESOURCE}/{uuid}` as const;

export type ApplicationByUuidParameters = paths[typeof APPLICATION_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type ApplicationByUuidResponse =
  paths[typeof APPLICATION_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useApplicationByUuidQuery(uuid: string, options?: Options<ApplicationByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<ApplicationByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [APPLICATION_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<ApplicationByUuidResponse>(
        `/v1/${APPLICATION_BY_UUID_RESOURCE}/${uuid}`,
        {
          params: requestParameters,
        },
      );

      return response.data;
    },
  });
}
